export default "__VITE_ASSET__CQj$yZx$__"